var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function({ hover }){return [_c('v-btn',{class:hover ? 'primary--text' : 'transparent',attrs:{"plain":"","ripple":false},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)]}}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }